<template>
  <v-container fluid>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12">
        <v-toolbar color="white" flat>
          <v-toolbar-title class="text-h5">个人信息</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-actions class="pb-0 px-4">
            <v-subheader class="px-0">个人信息</v-subheader>
          </v-card-actions>

          <v-card-text class="pt-0">
            <v-container fluid v-if="!identity">
              <v-row>
                <v-col cols="12">
                  <v-skeleton-loader type="list-item-avatar-two-line@7"></v-skeleton-loader>
                </v-col>
              </v-row>
            </v-container>
            <v-container fluid v-if="!!identity">
              <v-row>
                <v-col cols="12" sm="4" md="3">
                  <v-subheader class="text-body-1 black--text">用户名</v-subheader>
                </v-col>
                <v-col cols="12" sm="8" md="9">
                  <v-subheader class="text-body-1">{{identity.username}}</v-subheader>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" sm="4" md="3">
                  <v-subheader class="text-body-1 black--text">密码</v-subheader>
                </v-col>
                <v-col cols="12" sm="8" md="9">
                  <change-pass @save="savePassword"></change-pass>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" sm="4" md="3">
                  <v-subheader class="text-body-1 black--text">昵称</v-subheader>
                </v-col>
                <v-col cols="12" sm="8" md="9">
                  <text-editor :text-val="identity.nickname" text-key="nickname" :counter="32" @change="saveChange"/>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" sm="4" md="3">
                  <v-subheader class="text-body-1 black--text">邮箱</v-subheader>
                </v-col>
                <v-col cols="12" sm="8" md="9">
                  <text-editor :text-val="identity.email" text-key="email" :counter="32" @change="saveChange"/>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" sm="4" md="3">
                  <v-subheader class="text-body-1 black--text">电话</v-subheader>
                </v-col>
                <v-col cols="12" sm="8" md="9">
                  <text-editor :text-val="identity.phone" text-key="phone" :counter="32" @change="saveChange"/>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" sm="4" md="3">
                  <v-subheader class="text-body-1 black--text">创建时间</v-subheader>
                </v-col>
                <v-col cols="12" sm="8" md="9">
                  <v-subheader class="text-body-1">{{identity.createTime | dateFilter}}</v-subheader>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" sm="4" md="3">
                  <v-subheader class="text-body-1 black--text">修改时间</v-subheader>
                </v-col>
                <v-col cols="12" sm="8" md="9">
                  <v-subheader class="text-body-1">{{identity.updateTime | dateFilter}}</v-subheader>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" sm="4" md="3">
                  <v-subheader class="text-body-1 black--text">角色</v-subheader>
                </v-col>
                <v-col cols="12" sm="8" md="9">
                  <v-list nav>
                    <v-list-item-group color="blue">
                      <v-list-item v-for="item in identity.roles" :key="item.id">
                        <v-list-item-content>
                          <v-list-item-subtitle>{{item.name}} ({{item.code}})</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { format, parseISO } from 'date-fns'
import TextEditor from '@/components/TextEditor'
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
import ChangePass from '@/components/ChangePass'

export default {
  name: 'Profile',
  components: {
    ChangePass,
    TextEditor
  },
  computed: {
    identity () {
      return this.$store.state.identity
    }
  },
  filters: {
    dateFilter: value => {
      const time = parseISO(value)
      return format(time, 'yyyy-MM-dd HH:mm:ss')
    }
  },
  methods: {
    saveChange (arg) {
      const request = buildAxios()
      const payload = {}
      payload[arg.key] = arg.value

      this.$store.commit('updateIdentity', arg)

      request.post('auth/chProfile', payload)
        .then(res => {
          this.$store.commit('setIdentity', res.data.data)
          this.$emit('alert', {
            msg: '保存成功！',
            type: 'success'
          })
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    savePassword (arg) {
      const request = buildAxios()
      request.post('auth/chPass', {
        password: arg.oldPass,
        newPass: arg.newPass
      })
        .then(() => {
          this.$emit('alert', {
            msg: '密码修改成功！',
            type: 'success'
          })
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    }
  }
}
</script>
